import CampaignSegmentationDirective from './CampaignSegmentationDirective';
import 'edge/platform/campaign/module';

export default angular.module('edge.platform.segmentation.campaign', [
    'edge.platform.campaign'
])
    .directive('gwCampaignSegmentation', CampaignSegmentationDirective);